// Import Dateependencies
import React, { Component } from "react";
import { customTheme } from "themeProvider";
import TradeGothicWoof from "../assets/fonts/37F55A_0_0.woff";
import TradeGothicWoof2 from "../assets/fonts/37F55A_0_0.woff2";
import TradeGothicBoldWoof from "../assets/fonts/37F55A_2_0.woff";
import TradeGothicBoldWoof2 from "../assets/fonts/37F55A_2_0.woff2";


// Styles
// noinspection JSDuplicatedDeclaration
const styles = theme => ({
    "@global": {
        "html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video": {
            margin: "0",
            padding: "0",
            border: "0",
            fontSize: "100%",
            font: "inherit",
            verticalAlign: "baseline",
            boxSizing: "border-box"
        },
        "article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section": {
            display: "block"
        },
        body: {
            lineHeight: 1,
            background: theme.color.white,
            "fontFamily": "TradeGothicLTStd !important"
        },
        "ol, ul": {
            listStyle: "none"
        },
        "blockquote, q": {
            quotes: "none"
        },
        "blockquote:before, blockquote:after, q:before, q:after": {
            content: "none"
        },
        table: {
            borderCollapse: "collapse",
            borderSpacing: 0
        },
        img: {
            maxWidth: "100%",
            height: "auto"
        },
        h1: {
            fontSize: "44px",
            fontWeight: 300
        },
        h2: {
            fontSize: "26px",
            fontWeight: 300
        },
        h3: {
            fontSize: "21px",
            fontWeight: 300
        },
        p: {
            marginBottom: "10px",
            lineHeight: "1.4rem",
            color: theme.color.grey,
            fontWeight: 300,
            textAlign: "left"
        },
        button: {
            borderWidth: 0,
            backgroundColor: "transparent",
            padding: 0,
            outline: "none"
        },
        "@font-face": [{
            fontFamily: 'TradeGothicLTStd',
            fontStyle: "normal",
            src: `  url(${TradeGothicWoof2}) format('woff2'),
                    url(${TradeGothicWoof}) format('woff')`
        },
        {
            fontFamily: 'TradeGothicLTBold',
            fontStyle: "normal",
            src: `  url(${TradeGothicBoldWoof2}) format('woff2'),
                    url(${TradeGothicBoldWoof}) format('woff')`
        }]
    }
});


// Component
class BaseStyles extends Component {
    render() {
        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        );
    }
}

export default customTheme(styles, BaseStyles);



// WEBPACK FOOTER //
// ./src/styles/base.js